import CoreAPIService from '../../../utils/core-api';
import envConfig from '../../../config';
import { CreateRankDTO } from '../api-types';

const BASE_URL_GRP = 'services/dispatch_groups';
const BASE_URL_WL = envConfig.wl_url;
const BASE_API = envConfig.privapi_url;
const OVERRIDE_HEADER = { credentials: 'omit' };

export const RankAPI = {
    getRanks: () => CoreAPIService.get(`${BASE_URL_WL}`, null, OVERRIDE_HEADER, BASE_API),

    getRank: (id: string) => CoreAPIService.get(`${BASE_URL_WL}/${id}`, null, OVERRIDE_HEADER, BASE_API),

    getArea: (id: string) => CoreAPIService.get(`${BASE_URL_WL}/${id}/area`, null, OVERRIDE_HEADER, BASE_API),

    getDispatchGroups: () => CoreAPIService.get(`${BASE_URL_GRP}`, null, null, BASE_API),

    createRank: (data: CreateRankDTO) => CoreAPIService.post(`${BASE_URL_WL}/full`, data, OVERRIDE_HEADER, BASE_API),

    updateRank: (id: string, data: CreateRankDTO) =>
        CoreAPIService.patch(`${BASE_URL_WL}/${id}`, data, OVERRIDE_HEADER, BASE_API),

    deleteRank: (id: string) => CoreAPIService.delete(`${BASE_URL_WL}/${id}/full`, null, OVERRIDE_HEADER, BASE_API),
};
